import { useContext } from "react";
import makeStyles from "@mui/styles/makeStyles";
import Divider from "@mui/material/Divider";
import { StreamCardAttachments } from "components/CaseManagement/CaseStream/StreamCards/StreamCardAttachments";
import { EventCommentSection } from "components/CaseManagement/Comments/EventCommentSection";
import { EditorStateToHtml } from "components/TextEditors/EditorStateToHtml";
import Skeleton from "@mui/material/Skeleton";
import { EventsContext } from "contexts/EventsContext";
import { useFetchDeleteV2 } from "hooks/fetch/useFetchDeleteV2";
import { CaseContext } from "contexts/CaseContext";
import { CaseEvent } from "interfaces/case-event";
import { User } from "interfaces/user";
import { StreamCard } from "components/CaseManagement/CaseStream/StreamCard";
import { useEventAttachmentFilesQuery } from "hooks/queries/attachments";

const styles = {
  mainContent: {
    paddingTop: 0
  },
  postDescription: {
    fontSize: 16
  }
};

const useStyles = makeStyles(styles);

export interface PostCardProps {
  caseEvent: CaseEvent;
  user: User;
  datetime: string;
  refetchStream(): Promise<void>;
}

export const PostCard = ({
  caseEvent,
  user,
  datetime,
  refetchStream
}: PostCardProps): JSX.Element => {
  const classes = useStyles();

  const { refetchEvents } = useContext(EventsContext);
  const { refetchCase } = useContext(CaseContext);
  const { loading, deleteCallback: deleteEvents } = useFetchDeleteV2(
    `events/${caseEvent.id}`
  );
  const { data: attachmentsData } = useEventAttachmentFilesQuery({
    caseEventId: caseEvent.id
  });

  const handleDeletePost = async (): Promise<void> => {
    try {
      await deleteEvents();
      await Promise.all([refetchCase(), refetchEvents(), refetchStream()]);
    } catch (error) {
      console.error(error);
    }
  };

  if (loading) {
    return <Skeleton variant="rectangular" width={"100%"} height={200} />;
  }

  return (
    <StreamCard
      data-qa="CP-Card-Post"
      user={user}
      label="Post"
      datetime={datetime}
      menuOptions={[{ title: "Delete", onClick: handleDeletePost }]}
    >
      <div>
        <div className={classes.postDescription}>
          <EditorStateToHtml rawState={caseEvent.description} />
        </div>
      </div>
      <StreamCardAttachments
        attachments={attachmentsData}
        eventId={caseEvent.id}
      />
      <Divider />
      <EventCommentSection eventId={caseEvent.id} />
    </StreamCard>
  );
};
